import './styles.scss';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IStore} from '../../redux/interface';
import {Link, useParams} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {useGetTranslations} from '../../utils/hooks/useGetTranslations';
import {TranslationKeys} from '../../utils/constants/routeConstants';
import {
  articleAsyncActions, getTeiArticle, getTeiArticleReferences
} from '../../redux/pageAsyncActions';
import './styles.scss';
import Loader from '../../components/loader';

export const ArticleReferences: React.FunctionComponent = () => {
  const {
    article: {
      article,
      references
    },
    status: {
      loading
    }
  } = useSelector((state: IStore) => state);
  const dispatch = useDispatch();
  const {articleId} = useParams();

  useGetTranslations({
    translationKey: TranslationKeys.Article
  });

  useEffect(() => {
    if (articleId) {
      if (!article || article.id.toString() !== articleId) {
        dispatch(articleAsyncActions[getTeiArticle](articleId));
      }
      dispatch(articleAsyncActions[getTeiArticleReferences](articleId));
    }
  }, [articleId]);

  return <div className="references-page">
    {!references.length && loading.includes(getTeiArticleReferences) && <Loader className="references-page__loader"/>}
    {article && <header className="references-page__header">
      <h1><FormattedMessage
        id={'gritx.article.references'}
        defaultMessage={'References'}
      /></h1>
      {article && <Link to={`/article/${article.id}`} className="references-page__link">
        <FormattedMessage
          id={'gritx.article.backToArticle'}
          defaultMessage={'Back to article'}
        /></Link>}
    </header>}
    {article && <main className="references-page__container">
      <div className="references-page__body">
        {references.map((r, i) => {
          return <div className="references-page__body-reference" key={i}>
            <Link to={`/article/reference/${article.id}/${r.id}`}
              className="references-page__body-reference-link">{i + 1}.</Link>
            <p>{r.rawReference}</p></div>;
        })}
      </div>
    </main>}
  </div>;
};
